import type { Coupon } from '../../../types/HotelFromApi';
import request from '../request';

export type RequestData = {
  totalAmount: number;
  roomCount: number;

  propertyId?: string; // required only when voucherify is being used
  language?: string; // required only when voucherify is being used
  accountId?: string; // required only when voucherify is being used and user in logged in

  couponCodes?: string[]; // for internal app coupon codes
  discountId?: number; // for strapi campaigns
  zenkokuId?: number; // for strapi zenkoku

  discountCodes?: string[]; // for voucherify coupon codes
  promotionIds?: string[]; // for voucherify campaigns

  guestPerRooms: {
    adultMaleCount: number;
    seniorElementarySchoolChildCount: number;
    juniorElementarySchoolChildCount: number;
    infantWithMealCount: number;
    infantWithFutonCount: number;
    infantWithMealAndFutonCount: number;
    infantWithoutMealAndFutonCount: number;
  }[];
  plans: Partial<{
    date: string;
    planCode: string;
    planRates: Partial<{
      availabilityStatus: string;
      rateEffectiveDate: string;
      rateExpireDate: string;
      guestRates: Partial<{
        guestType: string;
        guestCount: number;
        guestRateTaxIncl: number;
        guestRateType: string;
        roomPricingType: string;
      }>[];
      total: Partial<{
        currencyCode: string;
        amountAfterTax: number;
      }>;
    }>[];
  }>[];
  affiliate_id?: string;
};

const validateCoupons = async (data: RequestData) => {
  const validCoupons = await request<Coupon[]>({
    url: `${process.env.NEXT_PUBLIC_BFF_URL}/bookings/validate-discount`,
    method: 'POST',
    data,
  });

  return validCoupons;
};

export default validateCoupons;
